<template>
  <div class="wary">
    <div id="header_nav" class="header">
      <div class="logo border_box">
        <div class="logo_img">
          <img src>
        </div>
        <div class="logo_txt wid300">天津市教育系统网络安全和舆情管控应急指挥平台</div>
      </div>
      <div class="userinfo_box">
        <div class="user_box" style="border: none;">
          <div class="el-dropdown" style="width: 150px;">
            <div class="user_img">
              <img src="/ssologin/static/images/user_icon.png">
              <span class="user_name">{{userName}}</span>
            </div>
            <ul class="subset_nav">
              <div style="position:absolute;height: 30px;width: 100%;top:-30px;left:0;"></div>
              <li @click="gosetting('/Set/userinfo')">个人信息</li>
              <li @click="gosetting('/Set/groupManagement')" v-if="funList.length > 0">系统设置</li>
              <li @click="gosetting('/Set/systemLog')">日志审计</li>
              <li @click="gosetting('/exit')">退出</li>
              <div class="popper__arrow"></div>
            </ul>
          </div>
        </div>
      </div>
      <div class="clear"></div>
    </div>
    <div id="goBack" class="goback" @click='$router.push("/loginIndex")'>返回</div>

    <div class="centre">
      <set-nav :hover="'opm'"></set-nav>
      <div class="set-infowary">
        <div class="tit">
          <a class="hover">人员管理</a>
          <p class="addrole" v-on:click="addRy()">添加人员</p>
        </div>
        <div class="group_management_wrap clearfix">
          <!--树-->
          <div class="group_tree_wrap">
            <div class="group_tree_box">
              <vue-ztree
                ref="tree"
                :list.sync="ztreeDataSource"
                :func="nodeClick"
                @editGroup="editGroup"
                :is-open="false"
                :is-check="false"
                @changeid="changeid"
              ></vue-ztree>
            </div>
          </div>
          <!--列表-->
          <div class="pm_wary">
            <div class="pm_search">
              <p>
                <input
                  type="text"
                  name="scarchinfo"
                  value
                  v-model="dataParameter.retrievalName"
                  placeholder="请输入登录帐号或姓名或邮箱或微信"
                >
                <i v-on:click="searchOrgInfo(1)"></i>
              </p>
              <p>
                登录帐号
                <a
                  href="javascript:void (0)"
                  :class="[dataParameter.state == '' ? 'hover': '']"
                  v-on:click="searchOrgInfo(2,'')"
                >不限</a> &nbsp;
                <a
                  href="javascript:void (0)"
                  :class="[dataParameter.state == '1' ? 'hover': '']"
                  v-on:click="searchOrgInfo(2,'1')"
                >启用</a> &nbsp;
                <a
                  href="javascript:void (0)"
                  :class="[dataParameter.state == '0' ? 'hover': '']"
                  v-on:click="searchOrgInfo(2,'0')"
                >停用</a>
              </p>
              <div style="overflow: hidden;">
                <span @click="someDel" style="cursor: pointer; color: #fff;float: right;margin-right: 30px;width:80px;height: 30px;background: #409eff;text-align: center; line-height: 30px;margin-bottom: 10px;border-radius: 5px;">批量删除</span>
              </div>
            </div>
            <!--列表-->
            <div class="pm_list" v-if="orguserData.length > 0">
              <table>
                <thead>
                  <tr>
                    <th class="wid0"></th>
                    <th class="wid1">序号</th>
                    <th class="wid2">登录帐号</th>
                    <th class="wid3">姓名</th>
                    <th class="wid4">邮箱</th>
                    <th class="wid5">所属角色</th>
                    <th class="wid6">状态</th>
                    <th class="wid7">操作</th>
                    <th class="wid8">排序</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(org,i) in orguserData">
                    <td><input type="checkbox" v-model="checkArr" :value="org"></td>
                    <td>{{keypage+i+1}}</td>
                    <td>{{org.account}}</td>
                    <td>{{org.userName}}</td>
                    <td>{{org.email}}</td>
                    <td
                      style="line-height: 24px;"
                      :title="org.roleName"
                    >{{org.roleName.length > 35 ? org.roleName.substr(0,35)+'...':org.roleName }}</td>
                    <td>
                      <span class="used" v-if="org.state=='1'" @click="changeState(org)">启用</span>
                      <span class="stop_used" v-else @click="changeState(org)">停用</span>
                    </td>
                    <td v-if="org.isSuper == 1 || org.isDQ == 1 || currentUserId==org.accountId">
                      <span class="tab_btn stop_used">编辑</span>
                      <span class="tab_btn stop_used">删除</span>
                      <span class="tab_btn stop_used">授权</span>
                    </td>
                    <td v-else>
                      <span
                        class="tab_btn"
                        v-on:click="updateOrg(org.id,org.account,org.userName,org.email,org.wechat,org.orgId)"
                      >编辑</span>
                      <span class="tab_btn" v-on:click="delOrg(org.id,org.userName,org.orgId)">删除</span>
                      <span
                        class="tab_btn"
                        v-on:click="accreditOrg(org.id,org.userName,org.account,org.orgId,org.accountId)"
                      >授权</span>
                    </td>
                    <td v-if="issearch">
                      <span class="stop_used">排序</span>
                    </td>
                    <td v-else>
                      <span
                        class="sort"
                        v-on:click="orgSort(keypage+i+1,org.id,org.userName,org.wechat,org.orgId)"
                      >排序</span>
                    </td>
                  </tr>
                </tbody>
              </table>
              <!--分页-->
              <pubpaging
                :pages="pages"
                :totals="total"
                :current.sync="dataParameter.pageNum"
                @navpage="msgListView"
              ></pubpaging>
            </div>
            <!--列表end-->
            <!--无数据-->
            <div v-else class="nodata">
              <div class="noData noDataBreowe">
                <div style="text-align: center;">
                  <img src="../../images/nodata.png">
                </div>

                <p style="text-align: center;">暂无数据</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="clear"></div>
    </div>
    <el-dialog title="账号信息"  :close-on-click-modal="false" :visible.sync="dialogFormVisible" width="550px">
      <el-form :model="form" :rules="rules">
        <el-form-item label="登录账号" :label-width="formLabelWidth" prop="account">
          <el-input :disabled="saveType == 'update'" v-model="form.account" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="姓名" :label-width="formLabelWidth" prop="userName">
          <el-input  v-model="form.userName" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="密码" :label-width="formLabelWidth" prop="password">
          <el-input type="password" v-model="form.password" auto-complete="off"></el-input>
          <p style="font-size:12px;line-height:20px">注：密码长度8位以上，密码复杂度为数字、字母及特殊字符两种以上组合!</p>
        </el-form-item>
        <el-form-item label="确认密码" :label-width="formLabelWidth"  prop="passwordtow">
          <el-input type="password" v-model="form.passwordtow" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="手机号" :label-width="formLabelWidth">
          <el-input v-model="form.phone" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="邮箱" :label-width="formLabelWidth">
          <el-input v-model="form.email" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="微信号" :label-width="formLabelWidth">
          <el-input v-model="form.wechat" auto-complete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveOrgInfo()">确 定</el-button>
      </div>
    </el-dialog>
    <!--编辑角色选择弹窗提示-->
    <div
      class="dialog_mask_box role_edit_select_dialog_mask"
      v-if="chooseType"
      the-id="compileOrgOpt"
    >
      <div class="dialog_mask_content role_edit_select_dialog">
        <div class="dialog_mask_header hide">
          <h1 class="dialog_mask_title">提示</h1>
          <span class="dialog_mask_close">&times;</span>
        </div>
        <div class="dialog_mask_detailed_content dialog_mask_detailed_content_1">
          <span class="dialog_mask_close" the-id="close_compile" @click="chooseType=false">&times;</span>
          <div class="group_sucess_tips">
            <p class="success_tips">请选择编辑内容</p>
          </div>
        </div>
        <div class="dialog_mask_btn_con">
          <div class="btn_box">
            <button type="button" class="btn save" @click="editInfo">编辑资料</button>
            <button type="button" class="btn cancle" the-id="changeOrg" @click="changeOrg">更换部门</button>
          </div>
        </div>
      </div>
    </div>
    <!-- 更换部门 -->
    <div
      class="dialog_mask_box change_epartment_dialog_mask"
      v-if="changeOrgType"
      the-id="update_branch"
    >
      <div class="dialog_mask_content change_epartment_dialog">
        <div class="dialog_mask_header">
          <h1 class="dialog_mask_title">更换部门</h1>
          <span class="dialog_mask_close" @click="changeOrgType=false">&times;</span>
        </div>
        <div class="change_epartment_box">
          <ul id="change_epartment" class="ztree"></ul>
        </div>
        <div class="dialog_mask_btn_con">
          <div class="btn_box">
            <button type="button" class="btn save" the-id="changebj_save" @click="changeOrgFn">保存</button>
            <button type="button" class="btn cancle" @click="changeOrgType=false">取消</button>
          </div>
        </div>
      </div>
    </div>
    <div class="dialog_mask_box group_tips_dialog_mask" v-if="saveSuccess">
      <div class="dialog_mask_content group_tips_dialog">
        <div class="dialog_mask_header hide">
          <h1 class="dialog_mask_title">提示</h1>
          <span class="dialog_mask_close">&times;</span>
        </div>
        <div class="dialog_mask_detailed_content">
          <div class="group_sucess_tips">
            <p class="success_tips">提示</p>
            <p class="success_info">成功！</p>
          </div>
        </div>
        <div class="dialog_mask_btn_con">
          <div class="btn_box">
            <button type="button" class="btn save" @click="saveSuccessFn">确认</button>
          </div>
        </div>
      </div>
    </div>

    <div class="dialog_mask_box role_del_dialog_mask" v-if="delType" the-id="del_wary">
      <div class="dialog_mask_content role_del_dialog">
        <div class="dialog_mask_header hide">
          <h1 class="dialog_mask_title">提示</h1>
          <span class="dialog_mask_close" @click="delType = false">&times;</span>
        </div>
        <div class="dialog_mask_detailed_content">
          <div class="group_sucess_tips">
            <p class="success_tips">提示</p>
            <p class="success_info">
              您要删除
              <span the-id="role"></span>该帐号吗？
            </p>
          </div>
        </div>
        <div class="dialog_mask_btn_con">
          <div class="btn_box">
            <button type="button" class="btn save" @click="delUserFn">确认</button>
            <button type="button" class="btn cancle" @click="delType = false">取消</button>
          </div>
        </div>
      </div>
    </div>

    <div class="dialog_mask_box role_del_dialog_mask" v-if="delsomeType" the-id="del_wary">
      <div class="dialog_mask_content role_del_dialog">
        <div class="dialog_mask_header hide">
          <h1 class="dialog_mask_title">提示</h1>
          <span class="dialog_mask_close" @click="delsomeType = false">&times;</span>
        </div>
        <div class="dialog_mask_detailed_content">
          <div class="group_sucess_tips">
            <p class="success_tips">提示</p>
            <p class="success_info">
              您要删除所选帐号吗？
            </p>
          </div>
        </div>
        <div class="dialog_mask_btn_con">
          <div class="btn_box">
            <button type="button" class="btn save" @click="delsomeUserFn">确认</button>
            <button type="button" class="btn cancle" @click="delsomeType = false">取消</button>
          </div>
        </div>
      </div>
    </div>



    <!--授权角色弹窗-->
    <div
      class="dialog_mask_box role_authorize_dialog_mask"
      v-if="changeRoleType"
      the-id="accreditWary"
    >
      <div class="dialog_mask_content role_authorize_dialog">
        <div class="dialog_mask_header">
          <h1 class="dialog_mask_title">授权角色</h1>
          <span class="dialog_mask_close" @click="changeRoleType=false">&times;</span>
        </div>
        <div class="dialog_mask_detailed_content">
          <div class="group_list clearfix">
            <label>登录账号</label>
            <span>{{account}}</span>
          </div>
          <div class="group_list clearfix">
            <label>姓名</label>
            <span>{{name}}</span>
          </div>
          <div class="group_list clearfix">
            <label>授权角色</label>
            <div class="roles_box" v-if="rolelist.length > 0">
              <label class="role_name" v-for="rl in rolelist">
                <input type="checkbox" name="roles" :disabled="isDisabled.includes(rl.roleId)" @change="changeOne(rl)" v-model="roleArray" :value="rl.roleId">
                {{rl.roleName}}
              </label>
            </div>
          </div>
        </div>
        <div class="dialog_mask_btn_con">
          <div class="btn_box">
            <button type="button" class="btn save" v-on:click="saveAccreditInfo()">保存</button>
            <button type="button" class="btn cancle" @click="changeRoleType=false">取消</button>
          </div>
        </div>
      </div>
    </div>

    <!--排序弹窗-->
    <div class="dialog_mask_box sort_dialog_mask" v-if="whereType" the-id="sortWary">
      <div class="dialog_mask_content sort_dialog">
        <div class="dialog_mask_header">
          <h1 class="dialog_mask_title">排序</h1>
          <span class="dialog_mask_close" @click="whereType = false">&times;</span>
        </div>
        <div class="dialog_mask_detailed_content">
          <div class="group_list clearfix">
            <label>姓名</label>
            <span>{{name}}</span>
          </div>
          <div class="group_list clearfix">
            <label>当前位置</label>
            <span>{{loc}}</span>
          </div>
          <div class="group_list clearfix">
            <label>调整位置</label>
            <input
              type="text"
              v-model="sequence"
              name="change_position"
              onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else if(this.value.length<=8){this.value=this.value.replace(/\D/g,'')}else{this.value=99999999}"
              onafterpaste="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else if(this.value.length <= 8){this.value=this.value.replace(/\D/g,'')}else{this.value = 99999999}"
            >
          </div>
          <div class="edit_tips hide edit_tips1">
            <span class="error err1">
              <em>*</em>
              <span class="error_info">错误信息展示</span>
            </span>
          </div>
        </div>
        <div class="dialog_mask_btn_con">
          <div class="btn_box">
            <button type="button" class="btn save" v-on:click="saveSort()">保存</button>
            <button type="button" class="btn cancle" @click="whereType = false">取消</button>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      :model="form2"
      title="编辑使用人数"
      :visible.sync="dialogFormVisible2"
      :close-on-click-modal="false"
      custom-class="add_group"
      @close="closeDialog"
      width="560px"
    >
      <el-form
        :model="form2"
        ref="form2"
        :rules="rules2"
        label-position="right"
        label-width="100px"
      >
        <el-form-item label="组织名称" prop="name">
          <el-input v-model="form2.name" disabled auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="使用人数" prop="maxUser" v-if="form2.pId != 0 ">
          <el-input
            v-model.number="form2.maxUser"
            controls-position="right"
            :min="0"
            label="描述文字"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item label="是否授权监测">
          <el-switch v-model="delivery"></el-switch>
        </el-form-item>-->
      </el-form>
      <!-- <div class="org_tips">备注：授权监测后会占用一个监测单位数，同时新增单位会有独立的监测舆情的能力</div> -->
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm('form2')">保 存</el-button>
        <el-button @click="dialogFormVisible2 = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import setNav from "./setNav.vue";
import pubpaging from "./pagination.vue";
import vueZtree from "./vue-ztree.vue";
import {
  getOrganizationalManagementTree,
  getOrgUserList,
  addOrgUser,
  editOrgUser,
  editOrgUserInfo,
  delOrgUser,
  getOrgUserRoleList,
  eidtOrgUserRole,
  updateSequence,
  editOrgUserState
} from "../../api/peopleApi";
import $ from "jquery";
import jQuery from "jquery";
import * as loginAPI from "@/api/login.js";
import {
  editGroupInfo,
} from "../../api/orgment.js";



export default {
  data() {
    var validatePass2 = (rule, value, callback) => {
      if (value !== this.form.password) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    var validateOrgname = (rule, value, callback) => {
      var newVal = value.trim().replace(/\s/g, ""); //去掉首位空格，过滤掉中间的空格后，进行验证
      if (newVal.length == 0) {
        callback(new Error("不能为空"));
      } else if (newVal.length > 20) {
        callback(new Error("最多20个字符"));
      } else {
        callback();
      }
    };
    return {
      editUserOrgid:'',
      currentUserAccountId:'',
      isDisabled:[], // 选择角色是否能选
      treeDeepCopy: [],
      checkArr: [],
      userName: this._util.getStorage("ssoUserInfo").name || "11",
      currentUserId:this._util.getStorage("ssoUserInfo").accountId || "",
      funList: [],
      total: 0,
      sequence: "",
      ryid: "",
      loc: "",
      keypage: 0,
      whereType: false,
      roleArray: [],
      account: "",
      name: "",
      delType: false,
      delsomeType: false,
      changeRoleType: false,
      nodesData: [],
      saveType: "",
      changeOrgType: false,
      chooseType: false, // 编辑 还是 更换部门的弹窗
      saveSuccess: false, //保存成功弹出框
      dataList: [],
      rolelist: [],
      ztreeDataSource: [],
      parentNodeModel: [], //当前点击节点父亲对象
      nodeModel: null, // 当前点击节点对象
      issearch: false, //是否搜索
      pages: 1, //页数
      keypage: 0, //循环键值页数
      dataParameter: {
        pageSize: "10", //每页条数
        orgIds: "", //集团id
        pageNum: 1, //当前页数
        retrievalName: "", //检束
        state: "" //状态 1启用 0停用
      },
      orguserData: [], //数据列表
      dialogFormVisible: false, //添加人弹层
      gridData: [], //编辑信息
      form: {
        id: "", //id号编辑用到
        orgId: "", //集团id号
        account: "", //手机号
        userName: "", //用户名
        password: "", //密码
        passwordtow: "", //确认密码
        phone: "",
        email: "", //邮箱
        wechat: "", //微信
        msUserId: this._util.getStorage("ssoUserInfo").msUserId || ""
      },
      formLabelWidth: "100px",
      rules: {
      // 要以数组形式展示
        account: [
          { required: true, message: " ", trigger: "blur" },
        ],
        userName: [
          { required: true, message: " ", trigger: "blur" },
        ],

        password: [
          { required: true, message: " ", trigger: "blur" },
        ],
        passwordtow: [
          { required: true, message: " ", trigger: "blur" },
        ]
      },
      dialogFormVisible2:false,
      form2: {
        name: "",
        pId: 0,
        orgLevel: 0,
        isDatanode: 0,
        maxUser: 0,
        msUserId: this._util.getStorage("ssoUserInfo").msUserId
      },
      rules2: {
        name: [{ validator: validateOrgname }]
      },
      // 记录默认展开节点
      showKeyId:[],
    };
  },
  components: {
    vueZtree,
    pubpaging,
    setNav
  },
  methods: {
    editGroup: function(model) {
      console.log(
        "groupManagement--------------------------------------------"
      );
      // console.log(model);
      // console.log(model.name);
    
      let id = model.id, //id作为新增元素的pId
        orgLevel = model.orgLevel, //组织层级
        isDatanode = model.isDatanode, //是否是数据节点   0否 1 是
        name = model.name,
        maxUser = model.maxUser,
        groupId = model.groupId,
        msUserId = model.msUserId,
        pId = model.pId;

      this.form2.pId = id;
      this.form2.orgLevel = orgLevel;
      this.form2.isDatanode = isDatanode;
      this.form2.name = name;
      this.form2.maxUser = maxUser;
      this.form2.groupId = groupId;
      this.form2.msUserId = msUserId;
      this.form2.pId = pId;
      this.form2.id = id;
      this.dialogFormVisible2 = true;
      console.log("-------this.form---------");
      // console.log(this.form);
    },
    closeDialog() {
      //console.log(11);
      //this.$refs[formName].resetFields();//清除表单验证
    },
    submitForm(formName) {
      var that = this;
      that.$refs[formName].validate(valid => {
        if (valid) {
          that.form2.groupId = parseInt(
            this._util.getStorage("ssoUserInfo").generalGroupId
          );
          that.form2.orgLevel = that.form2.orgLevel + 1;
          console.log("------------that.form2------------");
            editGroupInfo(that.form2)
              .then(function(res) {
                console.log("------------res------------");
                if (res.code == 0) {
                  // 0 失败  1 成功
                  that.dialogFormVisible2 = false;
                  that.$message.success("保存成功！")
                  that.showKeyId.push(that.form.pId);
                  let params = {
                    groupId: that._util.getStorage("ssoUserInfo")
                      .generalGroupId,
                    accountId: that._util.getStorage("ssoUserInfo").accountId
                  };
                  getOrganizationalManagementTree(params)
                    .then(function(res) {
                      // that.nodesData = [res.data[0]];
                      res.data.forEach((item,ind) => {
                        if (that.showKeyId.indexOf(item.id) >= 0) {
                          res.data[ind].isFolder = true;
                        }
                      })
                      console.log(that.ztreeDataSource)
                      that.ztreeDataSource = that.traversezTreeData(res.data);
                      // that.dataParameter.orgIds = that.ztreeDataSource[0].id;
                      // that.getOrgUserInfo();
                    })
                    .catch(err => {
                      console.log(err, "请求失败！");
                    });
                } else {
                  // 0 失败  1 成功
                  that.dialogFormVisible2 = false;
                  that.$message.error("保存失败");
                }
              })
              .catch(err => {
                console.log(err, "请求失败！");
              });
          

          // that.dialogFormVisible = false;
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    changeid:function (m) {
      console.log(m)
      if (m.isFolder) {
        this.showKeyId.push(m.id);
      } else {
        let ind = this.showKeyId.indexOf(m.id);
        this.showKeyId.splice(ind,1);
      }
      console.log(this.showKeyId)
    },
    /*
    *改变赋予的权限 判断其他权限是否可选
    */
    changeOne() {
        // this.isDisabled.splice(0,this.isDisabled.length)
        this.isDisabled = []
        // console.log(this.roleArray,'+++');
        console.log(this.roleArray.includes(1))
        console.log(this.roleArray.includes(2))
        if(this.roleArray.length <3){
          if(this.roleArray.includes(1)) {
            this.isDisabled.push(2)
          }  
          if(this.roleArray.includes(2)) {
            this.isDisabled.push(1)
          } 
    
          if(this.roleArray.includes(3)) {
            this.isDisabled.push(4)
          } 
          if(this.roleArray.includes(4)) {
            this.isDisabled.push(3)
          }      
        } 
         
    },
    someDel() {
      if(this.checkArr.length == 0) {
        alert("至少选择一个用户！")
        return
      }
      this.delsomeType = true
    },
     gosetting(a) {
      if (a !== "/exit") {
        this.$router.push({
          path: a
        });
      } else {
        localStorage.clear();
        window.localStorage.clear();
        // window.location = window.expertConfig.newUrl+'exit';
        let data = {
          accountId: this.accountId
        };
        loginAPI.dologOut(data).then(res => {
          if (res.code == 0) {
            this.$router.push({
              path: "/"
            });
          }
        });
      }
    },
    getRoleFunList() {
      let data = {
        accountId: this._util.getStorage("ssoUserInfo").accountId
      };
      loginAPI.getRoleFunList(data).then(res => {
        if (res.code == 0) {
          this.funList = res.data.funList;
          this._util.setStorage("ssoNav", res.data.funList[0].funSonList);
        }
      });
    },
    saveSort() {
      let data = {
        id: this.ryid,
        orgId: this.form.orgId,
        sequence: this.sequence
      };
      let _this = this
      updateSequence(data)
        .then((r) =>{
          if (r.data > 0) {
            _this.getOrgUserInfo()
            _this.whereType = false
          } else {
            _this.$message.error('失败!')
          }
        })
        .catch(err => {
          console.log(err, "请求失败！");
        });
    },
    changeState: function(item) {
      // console.log(item);
      var that = this;
      let data = {
        accountId: item.accountId,
        state: item.state == "1" ? "0" : "1"
      };

      editOrgUserState(data)
        .then(function(r) {
          if (r.data == "1") {
            alert("更改用户状态成功！");
          }
          that.orguserData.forEach(ii => {
            if (ii.accountId == item.accountId) {
              ii.state = ii.state == "1" ? "0" : "1";
            }
          });
        })
        .catch(err => {
          console.log(err, "请求失败！");
        });
    },
    saveAccreditInfo() {
      var rolesChecked = $("[name=roles]:checked"),
        leng = rolesChecked.length;
      var roles = "";
      if (leng > 0) {
        for (var i = 0; i < leng; i++) {
          var n = $(rolesChecked[i]);
          roles += n.val() + ",";
        }
        roles = roles.substr(0, roles.length - 1);
      }
      let data = {
        id: this.form.id || "",
        roleId: roles,
        orgId: this.editUserOrgid,
        accountId: this.currentUserAccountId
      };
      let _this = this;
      // console.log(data,'+++');
      eidtOrgUserRole(data)
        .then(function(res) {
          if (res.code == 0) {
            _this.changeRoleType = false;
            _this.saveSuccess = true;
          } else {
            _this.changeRoleType = false;

            _this.$message.error(res.msg);
          }
        })
        .catch(err => {
          console.log(err, "请求失败！");
        });
    },
    delsomeUserFn() {
      var _this = this
      let params = {
          groupId: this._util.getStorage("ssoUserInfo").generalGroupId,
          accountId: this._util.getStorage("ssoUserInfo").accountId
        };
      this.checkArr.forEach(item => {
        var data = {
          id: item.id,
          orgId: item.orgId
        }
        delOrgUser(data)
        .then(function(res) {
          if (res.code == 0) {
            _this.delsomeType = false;
            _this.saveSuccessFn()
            _this.checkArr = []
            getOrganizationalManagementTree(params)
            .then(function(res1) {
              res1.data.forEach((item,ind) => {
                if (_this.showKeyId.indexOf(item.id) >= 0) {
                  res1.data[ind].isFolder = true;
                }
              })
              _this.ztreeDataSource = _this.traversezTreeData(res1.data);
            })
            .catch(err => {
              console.log(err, "请求失败！");
            });
          } else {
            _this.delType = false;
            this.checkArr = []
            _this.$message.error(res.msg);
          }
        })
        .catch(err => {
          console.log(err, "请求失败！");
        });
      })

    },

    delUserFn() {
      let data = {
        id: this.form.id,
        orgId: this.form.orgId
      };
      let _this = this;
      let params = {
          groupId: this._util.getStorage("ssoUserInfo").generalGroupId,
          accountId: this._util.getStorage("ssoUserInfo").accountId
        };
      delOrgUser(data)
        .then(function(res) {
          if (res.code == 0) {
            _this.delType = false;
            _this.saveSuccess = true;
            getOrganizationalManagementTree(params)
                    .then(function(res1) {
                      res1.data.forEach((item,ind) => {
                        if (_this.showKeyId.indexOf(item.id) >= 0) {
                          res1.data[ind].isFolder = true;
                        }
                      })
                      _this.ztreeDataSource = _this.traversezTreeData(res1.data);
                    })
                    .catch(err => {
                      console.log(err, "请求失败！");
                    });
          } else {
            _this.delType = false;
            _this.$message.error(res.msg);
          }
        })
        .catch(err => {
          console.log(err, "请求失败！");
        });
    },
    saveSuccessFn() {
      this.saveSuccess = false;
      this.getOrgUserInfo();
    },
    // 点击节点
    nodeClick: function(m, parent, trees) {
      this.treeDeepCopy = trees;
      this.nodeModel = m; // 当前点击节点对象
      this.parentNodeModel = parent; //当前点击节点父亲对象
      this.dataParameter.orgIds = m.id;
      this.dataParameter.retrievalName = "";
      this.getOrgUserInfo();

      //        console.log(m);
      //        console.log(parent);

      // 导航菜单
      //        this.dataList=[]
      //        this.findById(this.ztreeDataSource,m.parentId)
      //        this.dataList= this.dataList.reverse();
      //        this.dataList.push(m);
    },
    searchOrgInfo: function(s, n) {
      //搜索
      if (s === 1) {
        //输入框搜索
        //          var scarchinfo = $('[name=scarchinfo]').val().replace(/(^\s*)|(\s*$)/g,'');
        this.issearch = true;
        //设置参数
        let searchOrgIds = ""
        if(this.searchOrgIds.length > 0) {
            searchOrgIds = this.searchOrgIds.substring(0,this.searchOrgIds.length-1);
        } 
        this.dataParameter.orgIds = searchOrgIds

        this.dataParameter.pageNum = 1;
        //查数据
        this.getOrgUserInfo();
      } else if (s === 2) {
        //登录状态搜索
        this.dataParameter.state = n;
        this.dataParameter.pageNum = 1;
        //查数据
        this.getOrgUserInfo();
      }
    },
    addRy: function() {
      //添加显示弹层
      (this.form.id = ""), //id号编辑用到
        (this.form.orgId = ""), //集团id号
        (this.form.account = ""), //
        (this.form.phone = ""), //手机号
        (this.form.userName = ""), //用户名
        (this.form.password = ""), //密码
        (this.form.passwordtow = ""), //确认密码
        (this.form.email = ""), //邮箱
        (this.form.wechat = "");
      this.saveType = "";
      this.dialogFormVisible = true;
    },
    saveOrgInfo: function() {
      //保存数据
      let
        isAccount = /^[\u4e00-\u9fa5_a-zA-Z0-9_]{1,50}$/ , 
        isMobile = /^1[3|5|8|7|9|6][0-9]{9}$/,
        isPwd = /((?=.*[a-z])(?=.*\d)|(?=[a-z])(?=.*[#@!~%^&*.])|(?=.*\d)(?=.*[#@!~%^&*.]))[a-z\d#@!~%^&*.]{8,}/gi,
        // isPwd = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,16}$/,
        isUserName = /[\u4e00-\u9fa5]/,
        isEmail = /^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/;
      let _this = this;
      //登陆账号验证
      if(_this.form.account.length == 0) {
        alert("账号不能为空")
        return false
      } else if(!isAccount.test(_this.form.account)) {
        alert("账号格式错误!(1-50位中文 字母 数字或组合!)")
        return false
      } 
      
      if (_this.form.phone.length != 0 && !isMobile.test(_this.form.phone)) {
        alert("手机号格式不正确，请重新输入");
        return false;
      }
      //姓名验证
      if (
        _this.form.userName.length == 0 ||
        !isUserName.test(_this.form.userName) ||
        _this.form.userName.length > 50
      ) {
        alert("姓名非空，中文50个字符");
        return false;
      }
      //密码验证
      if (_this.form.id == "") {
        if (
          _this.form.password.length == 0 ||
          !isPwd.test(_this.form.password)
        ) {
          alert("密码长度8位以上，密码复杂度为数字、字母及特殊字符两种以上组合!");
          return false;
        }
        //确认密码验证
        if (_this.form.password != _this.form.passwordtow) {
          alert("密码不一致");
          return false;
        }
      } else if (_this.form.password.length > 0) {
        //密码验证
        if (!isPwd.test(_this.form.password)) {
          alert("密码长度8位以上，密码复杂度为数字、字母及特殊字符两种以上组合!");
          return false;
        }
        if (_this.form.password != _this.form.passwordtow) {
          alert("密码不一致");
          return false;
        }
      }
      //邮箱验证
      if (
        _this.form.email != "" &&
        _this.form.email.length < 30 &&
        !isEmail.test(_this.form.email)
      ) {
        alert("邮箱格式不正确");
        return false;
      }
      //微信验证
      // if (_this.form.wechat != "" && !isMobile.test(_this.form.wechat)) {
      //   alert("微信号格式不正确");
      //   return false;
      // }
      // _this.form.orgId = _this.dataParameter.orgIds; //赋值一下集团id
      if (_this.saveType == "update") {
        editOrgUser(_this.form)
          .then(function(res) {
            if (res.code == 0) {
              _this.saveSuccess = true;
              _this.dialogFormVisible = false;
            } else {
              _this.dialogFormVisible = false;
              _this.$message.error(res.msg);
            }
          })
          .catch(err => {
            console.log(err, "请求失败！");
          });
      } else {
        _this.form.orgId = _this.dataParameter.orgIds; //赋值一下集团id
        let params = {
              groupId: this._util.getStorage("ssoUserInfo").generalGroupId,
              accountId: this._util.getStorage("ssoUserInfo").accountId
            };
        addOrgUser(_this.form)
          .then(function(res) {
            if (res.code == 0) {
              _this.saveSuccess = true;
              _this.dialogFormVisible = false;
              getOrganizationalManagementTree(params)
                    .then(function(res) {
                      res.data.forEach((item,ind) => {
                        if (_this.showKeyId.indexOf(item.id) >= 0) {
                          res.data[ind].isFolder = true;
                        }
                      })
                      _this.ztreeDataSource = _this.traversezTreeData(res.data);
                    })
                    .catch(err => {
                      console.log(err, "请求失败！");
                    });
            } else {
              _this.$message.error(res.msg);
              _this.dialogFormVisible = false;
            }
          })
          .catch(err => {
            console.log(err, "请求失败！");
          });
      }
    },
    findById: function(data, parentId) {
      var vm = this;
      for (var i = 0; i < data.length; i++) {
        if (parentId == data[i].id) {
          vm.dataList.push(data[i]);
          vm.findById(vm.ztreeDataSource, data[i].parentId);
          return data[i];
        }
        if (data[i].hasOwnProperty("children")) {
          vm.findById(data[i].children, parentId);
        }
      }
    },
    msgListView: function(curPage) {
      //分页组件跳转
      this.dataParameter.pageNum = curPage;
      this.getOrgUserInfo();
    },
    changeOrgFn() {
      var treeObj = $.fn.zTree.getZTreeObj("change_epartment");
      var nodes = treeObj.getCheckedNodes(true);
      if (nodes.length == 0) {
        alert("请选择要移动到那个部门？");
        return false;
      }
      let data = {
        id: this.form.id || "",
        orgId: nodes[0].id || ""
      };
      let _this = this;
      editOrgUserInfo(data)
        .then(function(res) {
          if (res.code == 0) {
            _this.changeOrgType = false;
            _this.saveSuccess = true;
          } else {
            _this.$message.error(res.msg);
            _this.changeOrgType = false;
          }
        })
        .catch(err => {
          console.log(err, "请求失败！");
        });
    },
    getOrgUserInfo: function() {
      //获得导航数据
      var _this = this;
      getOrgUserList(_this.dataParameter)
        .then(function(res) {
          if (res.data.data) {
            _this.orguserData = res.data.data || [];
            _this.pages = Math.ceil(res.data.totalCount / res.data.pageSize); //页数
            _this.keypage = parseInt(_this.dataParameter.pageNum - 1 + "0");
            _this.total = res.data.totalCount;
          } else {
            _this.orguserData = [];
            _this.pages = 0; //页数
            _this.keypage = 0;
          }
        })
        .catch(err => {
          console.log(err, "请求失败");
        });
    },
    //      traverseList:function (r) {
    //        //设置一下当前登录手机号
    //        if(r.length > 0){
    //          var dqs = VueCookies.get('DANGQIANS');
    //          for(var i in r){
    //            var account = md5("_"+r[i].account);
    //            if(dqs === account){
    //              r[i].isDQ = 1;
    //              break;
    //            }
    //          }
    //        }
    //        return r;
    //      },
    updateOrg: function(id, account, orgname, email, wechat, orgId) {
      (this.form.id = id), //id号编辑用到
        (this.form.account = account), //手机号
        (this.form.userName = orgname), //用户名
        (this.form.email = email || ""), //邮箱
        (this.form.wechat = wechat || ""),
        (this.form.orgId = orgId);
      this.saveType = "update";

      this.chooseType = true;

      //编辑
    },
    delOrg: function(id, name, orgId) {
      this.form.id = id;
      this.form.orgId = orgId;
      //删除
      this.delType = true;
    },
    accreditOrg: function(id, name, account, orgId,accountId) {
      this.changeRoleType = true;
      let _this = this;
      this.form.id = id;
      let data = {
        id: id,
        orgId: orgId
      };
      this.editUserOrgid = orgId;
      this.currentUserAccountId = accountId;
      this.account = account;
      this.name = name;
      getOrgUserRoleList(data)
        .then(function(res) {
          if (res.code == 0) {
            _this.rolelist = res.data;
            _this.roleArray = [];
            for (var i in _this.rolelist) {
              if (_this.rolelist[i].isChecked == 1) {
                _this.roleArray.push(_this.rolelist[i].roleId);
              }
            }
            _this.changeOne()
          }
          {
            _this.$message.error(res.msg);
          }
        })
        .catch(err => {
          console.log(err, "请求失败！");
        });
      //授权
    },
    orgSort: function(loc, id, name, wechart, orgId) {
      //排序
      this.loc = loc;
      this.name = name;
      this.ryid = id;
      this.form.orgId = orgId;
      this.whereType = true;
    },
    editInfo() {
      this.chooseType = false;
      this.dialogFormVisible = true;
    },
    changeOrg() {
      this.changeOrgType = true;
      this.chooseType = false;
      let _this = this;
      this.$nextTick(() => {
        _this.changeDepartment();
      });
    },
    traversezTreeData(data) {
      var zTreeData = [];
      for (let i in data) {
        let parentData = data[i];
        parentData.children = [];
        parentData.parentId = parentData.pId;
        parentData.ico = true; //是否显示增删改查icon
        parentData.user = true
        for (let j in data) {
          if (parentData.id == data[j].pId) {
            parentData.open = true;
            parentData.children.push(data[j]);
          }
        }
        if(this.nodeModel && this.nodeModel.id && data[i].id == this.nodeModel.id){
          parentData.clickNode = true    
        }
      }
      if (!(this.nodeModel && this.nodeModel.id)) {
        data[0].clickNode = true;
      }
      zTreeData[0] = data[0];
      return zTreeData;
    },
    changeDepartment() {
      var setting2 = {
        view: {
          showIcon: false
        },
        data: {
          simpleData: {
            enable: true
          }
        },
        check: {
          enable: true,
          chkStyle: "radio",
          radioType: "all"
        },
        callback: {}
      };
      // console.log(this.nodesData);
      var treeObj = $.fn.zTree.getZTreeObj("department");
      var orgID = this.form.orgId;
      if (this.nodesData) {
        if (orgID !== "") {
          for (var i in this.nodesData) {
            if (this.nodesData[i].id == orgID) {
              this.nodesData[i].chkDisabled = true;
            } else {
              this.nodesData[i].chkDisabled = false;
            }
          }
        }
        var zTreeObj = $.fn.zTree.init(
          $("#change_epartment"),
          setting2,
          this.nodesData
        );
        zTreeObj.expandAll(true);
      }
    }
  },
  computed: {
    searchOrgIds:function() {
      let orgIds = ""
      function recurFunc (data) {
        data.forEach(i => {
          orgIds += i.id + ','
          if (i.children) {
            recurFunc(i.children);
          }
        });
      };
      if(!this.nodeModel) {
        return ""
      }
      if(this.nodeModel.id) {
        orgIds += this.nodeModel.id + ","
      }
      if(this.nodeModel.children){
        recurFunc(this.nodeModel.children)
      }
      return orgIds
    },

  },
  mounted() {
    // 异步获取数据操作
    let _this = this;
    _this.getRoleFunList();

    let params = {
      groupId: this._util.getStorage("ssoUserInfo").generalGroupId,
      accountId: this._util.getStorage("ssoUserInfo").accountId
    };
    getOrganizationalManagementTree(params)
      .then(function(res) {
        _this.nodesData = [res.data[0]];
        _this.ztreeDataSource = _this.traversezTreeData(res.data);
        _this.dataParameter.orgIds = _this.ztreeDataSource[0].id;
        _this.getOrgUserInfo();
      })
      .catch(err => {
        console.log(err, "请求失败！");
      });
  }
};
</script>
<style>
@import "../../../static/style/rolePerm.css";
.clear {
  clear: both;
  display: block;
}
.wary {
  background-color: #f2f2f2;
  width: 100%;
}
.centre {
  margin: 30px auto 30px;
  width: 94%;
  min-height: 500px;
  position: relative;
}

.addrole {
  display: block;
  float: right;
  color: #33a7ff;
  font-size: 14px;
  margin-right: 20px;
  cursor: pointer;
}
.set-infowary .group_management_wrap {
  width: 100%;
  margin: 12px auto 0;
  padding-bottom: 20px;
}
.set-infowary .group_management_wrap .group_tree_wrap {
  width: 240px;
  float: left;
  max-height: 600px;
  border: 1px solid #e6e6e6;
  border-radius: 6px;
}
.set-infowary .group_management_wrap .group_tree_wrap .group_tree_box {
  border-radius: 6px;
  overflow: auto;
  background-color: #fff;
}
.set-infowary .group_management_wrap .group_tree_wrap .group_tree_box .ztree {
  padding: 0;
  min-height: 779px;
  max-height: 1100px;
}

.set-infowary .group_management_wrap .group_tree_wrap .group_tree_box .ztree * {
  font-size: 14px;
}

.set-infowary
  .group_management_wrap
  .group_tree_wrap
  .group_tree_box
  .ztree
  li {
  line-height: 40px;
}

.set-infowary
  .group_management_wrap
  .group_tree_wrap
  .group_tree_box
  .ztree
  li
  a {
  line-height: 40px;
  height: 40px;
  padding-top: 0;
}
ul.ztree {
  height: 700px;
}
/*弹层*/
.el-dialog {
  border-radius: 6px;
}
.el-dialog__header {
  border-bottom: 1px solid #e6e6e6;
  font-size: 16px;
  color: #333333;
  font-weight: bold;
  padding: 0px;
  height: 48px;
  line-height: 48px;
  padding: 0 30px;
}
.el-dialog__headerbtn {
  top: 16px;
}
.el-form-item__label {
  color: #999;
}
.el-form-item {
  margin-bottom: 20px;
}
.noData {
}
.dialog_mask_box input {
  outline: none;
  border: 1px solid #e6e6e6;
  border-radius: 6px;
  padding: 0 10px;
}
.dialog_mask_box input:focus {
  border: 1px solid #33a7ff;
  border-radius: 6px;
}
.hide {
  display: none;
}
.error {
  color: #ff3333;
  font-size: 12px;
}
.error em {
  font-style: normal;
  margin-right: 10px;
}
.dialog_mask_box {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 888;
}
.dialog_mask_box .dialog_mask_content {
  background: #fff;
  border-radius: 6px;
  position: fixed;
  left: 50%;
  top: 50%;
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
.dialog_mask_box .dialog_mask_content .dialog_mask_header {
  height: 48px;
  line-height: 48px;
  border-bottom: 1px solid #e6e6e6;
  position: relative;
}
.dialog_mask_box .dialog_mask_content .dialog_mask_header .dialog_mask_title {
  padding: 0 30px;
  font-size: 16px;
  color: #333333;
  font-weight: bold;
}
.dialog_mask_box .dialog_mask_content .dialog_mask_header .dialog_mask_close {
  position: absolute;
  right: 30px;
  top: 14px;
  width: 20px;
  height: 20px;
  line-height: 20px;
  color: #686868;
  font-size: 24px;
  z-index: 2;
  font-weight: bold;
  cursor: pointer;
}
.dialog_mask_box .dialog_mask_content .dialog_mask_detailed_content {
  padding: 30px 30px 0;
}
.dialog_mask_box .dialog_mask_content .dialog_mask_btn_con {
  padding: 18px 0;
}
.dialog_mask_box .dialog_mask_content .dialog_mask_btn_con .btn_box {
  font-size: 0;
  text-align: center;
}
.dialog_mask_box .dialog_mask_content .dialog_mask_btn_con .btn_box .btn {
  outline: none;
  width: 120px;
  height: 36px;
  line-height: 36px;
  text-align: center;
  font-size: 14px;
  font-weight: bold;
  border-radius: 6px;
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  cursor: pointer;
}
.dialog_mask_box .dialog_mask_content .dialog_mask_btn_con .btn_box .btn.save {
  color: #fff;
  background: #33a7ff;
  border: 1px solid #33a7ff;
}
.dialog_mask_box
  .dialog_mask_content
  .dialog_mask_btn_con
  .btn_box
  .btn.cancle {
  color: #666666;
  background: #ffffff;
  border: 1px solid #bbbbbb;
  margin-left: 20px;
}
.group_tips_dialog,
.role_del_dialog,
.role_edit_select_dialog {
  width: 300px;
}
.group_tips_dialog .group_sucess_tips .success_tips,
.role_del_dialog .group_sucess_tips .success_tips,
.role_edit_select_dialog .group_sucess_tips .success_tips {
  color: #666;
  font-size: 12px;
  text-align: center;
  margin-bottom: 18px;
}
.group_tips_dialog .group_sucess_tips .success_info,
.role_del_dialog .group_sucess_tips .success_info {
  color: #333;
  font-size: 14px;
  text-align: center;
  font-weight: bold;
}
.change_epartment_dialog {
  width: 540px;
}
.change_epartment_box {
  padding: 10px 30px 0;
  max-height: 360px;
  overflow: auto;
}
.change_epartment_dialog .dialog_mask_btn_con {
  border-top: 1px solid #e6e6e6;
}
/*排序*/
.sort_dialog .group_list {
  font-size: 0; /*为了对齐*/
}
.sort_dialog .group_list label {
  margin-right: 10px;
}
.sort_dialog .edit_tips {
  margin: 10px 0 10px 110px;
}
.dialog_mask_box .dialog_mask_content .dialog_mask_detailed_content_1 {
  position: relative;
}
.dialog_mask_box
  .dialog_mask_content
  .dialog_mask_detailed_content_1
  .dialog_mask_close {
  position: absolute;
  right: 15px;
  top: 10px;
  width: 20px;
  height: 20px;
  line-height: 20px;
  color: #686868;
  font-size: 24px;
  z-index: 2;
  font-weight: bold;
  cursor: pointer;
}
.role_authorize_dialog,
.sort_dialog {
  width: 540px;
}
.role_authorize_dialog .group_list,
.sort_dialog .group_list {
  margin-bottom: 18px;
}
.role_authorize_dialog .group_list label {
  margin-right: 10px;
  float: left;
}
.role_authorize_dialog .group_list span,
.sort_dialog .group_list span {
  font-size: 14px;
  color: #666;
}
.role_authorize_dialog .group_list .roles_box {
  display: inline-block;
  width: 360px;
}
.role_authorize_dialog .group_list .role_name {
  width: auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin: 0 30px 10px 0;
}
.role_authorize_dialog .group_list input[type="checkbox"] {
  width: auto;
  margin-right: 10px;
}
.sort_dialog .group_list {
  font-size: 0; /*为了对齐*/
}
.sort_dialog .group_list label {
  margin-right: 10px;
}
.sort_dialog .edit_tips {
  margin: 10px 0 10px 110px;
}
.dialog_mask_box .dialog_mask_content .dialog_mask_detailed_content_1 {
  position: relative;
}
.dialog_mask_box
  .dialog_mask_content
  .dialog_mask_detailed_content_1
  .dialog_mask_close {
  position: absolute;
  right: 15px;
  top: 10px;
  width: 20px;
  height: 20px;
  line-height: 20px;
  color: #686868;
  font-size: 24px;
  z-index: 2;
  font-weight: bold;
  cursor: pointer;
}
.add_user_box .group_list label,
.role_authorize_dialog .group_list label,
.sort_dialog .group_list label {
  display: inline-block;
  width: 100px;
  font-size: 14px;
  color: #999;
  text-align: right;
}
.dialog_mask_box input {
  height: 40px;
}

</style>

<style scoped lang="less">
.goback {
    background: #0f2847;
    cursor: pointer;
    margin-left: 40px;
    width: 100px;
    height: 40px;
    line-height: 30px;
    text-align: center;
    color: #fff;
    margin-top: 10px;
    border-radius: 10px;
}
.header {
  width: 100%;
  height: 64px;
  background-color: #0f2847;
  box-shadow: 0 2px 15px #e5e5e5;
  z-index: 888;
  min-width: 1100px;
  position: relative;
  .logo {
    width: 600px;
    float: left;
    height: 64px;
    padding: 8px 0;
    margin-left: 3%;
    overflow: hidden;
    font-size: 0;
    .wid300 {
      max-width: 100%;
      line-height: 48px;
    }
    .logo_txt {
      display: inline-block;
      font-size: 24px;
      color: #fff;
      vertical-align: middle;
      max-height: 48px;
      overflow: hidden;
    }
  }
  .userinfo_box {
    float: right;
    // margin-right: 5%;
  }
  .sys_setup {
    display: inline-block;
    width: 23px;
    height: 23px;
    background: url(../../images/setting.png) no-repeat;
    background-size: 20px 20px;
    vertical-align: top;
    margin: -1px 0 0 10px;
    cursor: pointer;
  }
}
.userSetBox {
  position: relative;
  z-index: 1000;
}
.userinfo_box {
  float: right;
  /* // margin-right: 5%;
  // margin-top: 2%; */
}
.userinfo_box .user_box {
  float: left;
  border-left: 1px solid #a5aabb;
  height: 18px;
  line-height: 18px;
  margin-top: 23px;
  margin-left: 12px;
  font-size: 0;
  position: relative;
}
.userinfo_box .user_box div.user_img {
  margin: 0 12px;
  cursor: pointer;
  display: flex;
}
.userinfo_box .user_box div.user_img img {
  display: inline-block;
  width: 16px;
  height: 16px;
  vertical-align: top;
  margin-top: 1px;
  border: 0px none;
}
.userinfo_box .user_box div.user_img span.user_name {
  font-size: 14px;
  color: #fff;
  white-space: nowrap;
}
.userinfo_box .user_box .subset_nav {
  position: absolute;
  top: 26px;
  left: -8px;
  padding: 10px 0;
  margin: 5px 0;
  background-color: #fff;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  width: 96px;
  display: none;
}
.userinfo_box .user_box .el-dropdown:hover .subset_nav {
  display: block;
}
.userinfo_box .user_box .subset_nav li {
  list-style: none;
  line-height: 36px;
  padding: 0 20px;
  margin: 0;
  font-size: 14px;
  color: #606266;
  cursor: pointer;
  outline: 0;
  width: auto;
  height: auto;
}
.userinfo_box .user_box .subset_nav li:hover {
  background-color: #ecf5ff;
}
.userinfo_box .user_box .subset_nav li:hover a {
  color: #409eff;
}
.userinfo_box .user_box .subset_nav li a {
  font-size: 14px;
  font-family: "\5B8B\4F53";
  color: #606266;
}
.userinfo_box .user_box .subset_nav li a:hover {
  color: #409eff;
}
.userinfo_box .user_box .subset_nav li a.hover {
  color: #409eff;
}
.userinfo_box .user_box .subset_nav .popper__arrow,
.userinfo_box .user_box .subset_nav .popper__arrow::after {
  position: absolute;
  display: block;
  width: 0;
  height: 0;
  border-color: transparent;
  border-style: solid;
}
.userinfo_box .user_box .subset_nav .popper__arrow {
  border-width: 6px;
  filter: drop-shadow(0 2px 12px rgba(0, 0, 0, 0.03));
  left: 50%;
  top: -6px;
  border-top-width: 0;
  border-bottom-color: #ebeef5;
  margin-left: -6px;
}
.userinfo_box .user_box .subset_nav .popper__arrow::after {
  content: " ";
  border-width: 6px;
  border-bottom-color: #fff;
  border-top-width: 0;
  margin-left: -6px;
  top: 1px;
}

</style>


// WEBPACK FOOTER //
// src/components/Setting/Opm.vue